import React from "react";

export default function SongkranFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".son4-1{fill:#d36011}.son4-2{fill:#ff9d00}.son4-3{fill:#ffb800}.son4-4{fill:#ff8600}.son4-5{fill:#12a055}.son4-6{fill:#ff8900}.son4-7{fill:#ff7b00}.son4-8{fill:#ffb300}.son4-9{fill:#ffb100}.son4-10{fill:#fb0}.son4-11{fill:#068e43}.son4-12{fill:#ffa100}.son4-13{fill:#ffae00}.son4-14{fill:#ffb200}.son4-15{fill:#ff7d00}.son4-16{fill:#ffa700}.son4-17{fill:#ffa600}.son4-18{fill:#ff7300}.son4-19{fill:#ff7a00}.son4-20{fill:#ffac00}.son4-21{fill:#ffb600}.son4-22{fill:#ff8300}.son4-23{fill:#f80}.son4-24{fill:#ff9600}.son4-25{fill:#ff9000}.son4-26{fill:#ff9400}.son4-27{fill:#ffba00}.son4-28{fill:#ff9a00}.son4-29{fill:#ff9b00}.son4-30{fill:#ff8400}.son4-31{fill:#ff7c00}.son4-32{fill:#ff7500}.son4-33{fill:#ffa300}.son4-34{fill:#ffb000}.son4-35{fill:#ffb700}.son4-36{fill:#ff9200}.son4-37{fill:#ff7e00}.son4-38{fill:#ffbf00}.son4-39{fill:#ff8d00}.son4-40{fill:#ff9e00}.son4-41{fill:#ff8100}.son4-42{fill:orange}.son4-44{fill:#ff9500}.son4-45{fill:#ff8f00}.son4-46{fill:#ff9f00}.son4-47{fill:#ff7400}.son4-48{fill:#ffab00}.son4-49{fill:#ff8c00}.son4-50{fill:#ffbe00}.son4-51{fill:#ff9300}.son4-52{fill:#ffbd00}.son4-53{fill:#ffad00}.son4-54{fill:#ff7000}.son4-55{fill:#ffaf00}.son4-56{fill:#ffb900}.son4-58{fill:#ffb400}.son4-60{fill:#ff8000}.son4-61{fill:#ff7f00}.son4-62{fill:#f70}.son4-63{fill:#ff8b00}.son4-64{fill:#ff7800}.son4-65{fill:#ff7900}.son4-66{fill:#bc520a}.son4-67{fill:#ffb500}.son4-68{fill:#ff7100}.son4-69{fill:#f90}.son4-70{fill:#ff9c00}.son4-71{fill:#ffa800}.son4-72{fill:#ffa000}.son4-73{fill:#ffa900}.son4-74{fill:#ffbc00}.son4-75{fill:#ff7200}.son4-76{fill:#ffa400}.son4-77{fill:#ff8e00}.son4-78{fill:#ff8a00}.son4-79{fill:#fa0}.son4-80{fill:#ff7600}.son4-81{fill:#ffa200}.son4-82{fill:#ff8200}.son4-83{fill:#ff8700}.son4-84{fill:#ff9100}.son4-85{fill:#ff8500}.son4-86{fill:#ff9800}"
            }
          </style>
        </defs>

        <path
          d="M527.55 529.48h941.04v20.39H527.55zM527.55 549.87h941.04v9.88H527.55z"
          className="son4-38"
        />
        <path d="M527.55 559.76h941.04v9.88H527.55z" className="son4-50" />
        <path d="M527.55 569.64h941.04v9.88H527.55z" className="son4-52" />
        <path d="M527.55 579.53h941.04v9.88H527.55z" className="son4-74" />
        <path d="M527.55 589.41h941.04v9.88H527.55z" className="son4-10" />
        <path d="M527.55 599.29h941.04v9.88H527.55z" className="son4-27" />
        <path d="M527.55 609.18h941.04v9.88H527.55z" className="son4-56" />
        <path d="M527.55 619.06h941.04v9.88H527.55z" className="son4-3" />
        <path d="M527.55 628.94h941.04v9.88H527.55z" className="son4-35" />
        <path d="M527.55 638.83h941.04v9.88H527.55z" className="son4-21" />
        <path d="M527.55 648.71h941.04v9.88H527.55z" className="son4-67" />
        <path d="M527.55 658.6h941.04v9.88H527.55z" className="son4-58" />
        <path d="M527.55 668.48h941.04v9.88H527.55z" className="son4-8" />
        <path d="M527.55 678.36h941.04v9.88H527.55z" className="son4-14" />
        <path d="M527.55 688.25h941.04v9.88H527.55z" className="son4-9" />
        <path d="M527.55 698.13h941.04v9.88H527.55z" className="son4-34" />
        <path d="M527.55 708.01h941.04v9.88H527.55z" className="son4-55" />
        <path d="M527.55 717.9h941.04v9.88H527.55z" className="son4-13" />
        <path d="M527.55 727.78h941.04v9.88H527.55z" className="son4-53" />
        <path d="M527.55 737.67h941.04v9.88H527.55z" className="son4-20" />
        <path d="M527.55 747.55h941.04v9.88H527.55z" className="son4-48" />
        <path d="M527.55 757.43h941.04v9.88H527.55z" className="son4-79" />
        <path d="M527.55 767.32h941.04v9.88H527.55z" className="son4-73" />
        <path d="M527.55 777.2h941.04v9.88H527.55z" className="son4-71" />
        <path d="M527.55 787.09h941.04v9.88H527.55z" className="son4-16" />
        <path d="M527.55 796.97h941.04v9.88H527.55z" className="son4-17" />
        <path d="M527.55 806.85h941.04v9.88H527.55z" className="son4-42" />
        <path d="M527.55 816.74h941.04v9.88H527.55z" className="son4-76" />
        <path d="M527.55 826.62h941.04v9.88H527.55z" className="son4-33" />
        <path d="M527.55 836.5h941.04v9.88H527.55z" className="son4-81" />
        <path d="M527.55 846.39h941.04v9.88H527.55z" className="son4-12" />
        <path d="M527.55 856.27h941.04v9.88H527.55z" className="son4-72" />
        <path d="M527.55 866.16h941.04v9.88H527.55z" className="son4-46" />
        <path d="M527.55 876.04h941.04v9.88H527.55z" className="son4-40" />
        <path d="M527.55 885.92h941.04v9.88H527.55z" className="son4-2" />
        <path d="M527.55 895.81h941.04v9.88H527.55z" className="son4-70" />
        <path d="M527.55 905.69h941.04v9.88H527.55z" className="son4-29" />
        <path d="M527.55 915.58h941.04v9.88H527.55z" className="son4-28" />
        <path d="M527.55 925.46h941.04v9.88H527.55z" className="son4-69" />
        <path d="M527.55 935.34h941.04v9.88H527.55z" className="son4-86" />
        <path d="M527.55 945.23h941.04v9.88H527.55z" className="son4-24" />
        <path d="M527.55 955.11h941.04v9.88H527.55z" className="son4-44" />
        <path d="M527.55 964.99h941.04v9.88H527.55z" className="son4-26" />
        <path d="M527.55 974.88h941.04v9.88H527.55z" className="son4-51" />
        <path d="M527.55 984.76h941.04v9.88H527.55z" className="son4-36" />
        <path d="M527.55 994.65h941.04v9.88H527.55z" className="son4-84" />
        <path d="M527.55 1004.53h941.04v9.88H527.55z" className="son4-25" />
        <path d="M527.55 1014.41h941.04v9.88H527.55z" className="son4-45" />
        <path d="M527.55 1024.3h941.04v9.88H527.55z" className="son4-77" />
        <path d="M527.55 1034.18h941.04v9.88H527.55z" className="son4-39" />
        <path d="M527.55 1044.07h941.04v9.88H527.55z" className="son4-49" />
        <path d="M527.55 1053.95h941.04v9.88H527.55z" className="son4-63" />
        <path d="M527.55 1063.83h941.04v9.88H527.55z" className="son4-78" />
        <path d="M527.55 1073.72h941.04v9.88H527.55z" className="son4-6" />
        <path d="M527.55 1083.6h941.04v9.88H527.55z" className="son4-23" />
        <path d="M527.55 1093.48h941.04v9.88H527.55z" className="son4-83" />
        <path d="M527.55 1103.37h941.04v9.88H527.55z" className="son4-4" />
        <path d="M527.55 1113.25h941.04v9.88H527.55z" className="son4-85" />
        <path d="M527.55 1123.14h941.04v9.88H527.55z" className="son4-30" />
        <path d="M527.55 1133.02h941.04v9.88H527.55z" className="son4-22" />
        <path d="M527.55 1142.9h941.04v9.88H527.55z" className="son4-82" />
        <path d="M527.55 1152.79h941.04v9.88H527.55z" className="son4-41" />
        <path d="M527.55 1162.67h941.04v9.88H527.55z" className="son4-60" />
        <path d="M527.55 1172.56h941.04v9.88H527.55z" className="son4-61" />
        <path d="M527.55 1182.44h941.04v9.88H527.55z" className="son4-37" />
        <path d="M527.55 1192.32h941.04v9.88H527.55z" className="son4-15" />
        <path d="M527.55 1202.21h941.04v9.88H527.55z" className="son4-31" />
        <path d="M527.55 1212.09h941.04v9.88H527.55z" className="son4-7" />
        <path d="M527.55 1221.97h941.04v9.88H527.55z" className="son4-19" />
        <path d="M527.55 1231.86h941.04v9.88H527.55z" className="son4-65" />
        <path d="M527.55 1241.74h941.04v9.88H527.55z" className="son4-64" />
        <path d="M527.55 1251.63h941.04v9.88H527.55z" className="son4-62" />
        <path d="M527.55 1261.51h941.04v9.88H527.55z" className="son4-80" />
        <path d="M527.55 1271.39h941.04v9.88H527.55z" className="son4-32" />
        <path d="M527.55 1281.28h941.04v9.88H527.55z" className="son4-47" />
        <path d="M527.55 1291.16h941.04v9.88H527.55z" className="son4-18" />
        <path d="M527.55 1301.05h941.04v9.88H527.55z" className="son4-75" />
        <path d="M527.55 1310.93h941.04v9.88H527.55z" className="son4-68" />
        <path
          d="M527.55 1320.81h941.04v9.88H527.55zM527.55 1330.7h941.04v139.82H527.55z"
          className="son4-54"
        />
        <path d="M384.8 386.72h1226.56v163.16H384.8z" className="son4-38" />
        <path d="M384.8 549.87h1226.56v9.88H384.8z" className="son4-38" />
        <path d="M384.8 559.76h1226.56v9.88H384.8z" className="son4-50" />
        <path d="M384.8 569.64h1226.56v9.88H384.8z" className="son4-52" />
        <path d="M384.8 579.53h1226.56v9.88H384.8z" className="son4-74" />
        <path d="M384.8 589.41h1226.56v9.88H384.8z" className="son4-10" />
        <path d="M384.8 599.29h1226.56v9.88H384.8z" className="son4-27" />
        <path d="M384.8 609.18h1226.56v9.88H384.8z" className="son4-56" />
        <path d="M384.8 619.06h1226.56v9.88H384.8z" className="son4-3" />
        <path d="M384.8 628.94h1226.56v9.88H384.8z" className="son4-35" />
        <path d="M384.8 638.83h1226.56v9.88H384.8z" className="son4-21" />
        <path d="M384.8 648.71h1226.56v9.88H384.8z" className="son4-67" />
        <path d="M384.8 658.6h1226.56v9.88H384.8z" className="son4-58" />
        <path d="M384.8 668.48h1226.56v9.88H384.8z" className="son4-8" />
        <path d="M384.8 678.36h1226.56v9.88H384.8z" className="son4-14" />
        <path d="M384.8 688.25h1226.56v9.88H384.8z" className="son4-9" />
        <path d="M384.8 698.13h1226.56v9.88H384.8z" className="son4-34" />
        <path d="M384.8 708.01h1226.56v9.88H384.8z" className="son4-55" />
        <path d="M384.8 717.9h1226.56v9.88H384.8z" className="son4-13" />
        <path d="M384.8 727.78h1226.56v9.88H384.8z" className="son4-53" />
        <path d="M384.8 737.67h1226.56v9.88H384.8z" className="son4-20" />
        <path d="M384.8 747.55h1226.56v9.88H384.8z" className="son4-48" />
        <path d="M384.8 757.43h1226.56v9.88H384.8z" className="son4-79" />
        <path d="M384.8 767.32h1226.56v9.88H384.8z" className="son4-73" />
        <path d="M384.8 777.2h1226.56v9.88H384.8z" className="son4-71" />
        <path d="M384.8 787.09h1226.56v9.88H384.8z" className="son4-16" />
        <path d="M384.8 796.97h1226.56v9.88H384.8z" className="son4-17" />
        <path d="M384.8 806.85h1226.56v9.88H384.8z" className="son4-42" />
        <path d="M384.8 816.74h1226.56v9.88H384.8z" className="son4-76" />
        <path d="M384.8 826.62h1226.56v9.88H384.8z" className="son4-33" />
        <path d="M384.8 836.5h1226.56v9.88H384.8z" className="son4-81" />
        <path d="M384.8 846.39h1226.56v9.88H384.8z" className="son4-12" />
        <path d="M384.8 856.27h1226.56v9.88H384.8z" className="son4-72" />
        <path d="M384.8 866.16h1226.56v9.88H384.8z" className="son4-46" />
        <path d="M384.8 876.04h1226.56v9.88H384.8z" className="son4-40" />
        <path d="M384.8 885.92h1226.56v9.88H384.8z" className="son4-2" />
        <path d="M384.8 895.81h1226.56v9.88H384.8z" className="son4-70" />
        <path d="M384.8 905.69h1226.56v9.88H384.8z" className="son4-29" />
        <path d="M384.8 915.58h1226.56v9.88H384.8z" className="son4-28" />
        <path d="M384.8 925.46h1226.56v9.88H384.8z" className="son4-69" />
        <path d="M384.8 935.34h1226.56v9.88H384.8z" className="son4-86" />
        <path d="M384.8 945.23h1226.56v9.88H384.8z" className="son4-24" />
        <path d="M384.8 955.11h1226.56v9.88H384.8z" className="son4-44" />
        <path d="M384.8 964.99h1226.56v9.88H384.8z" className="son4-26" />
        <path d="M384.8 974.88h1226.56v9.88H384.8z" className="son4-51" />
        <path d="M384.8 984.76h1226.56v9.88H384.8z" className="son4-36" />
        <path d="M384.8 994.65h1226.56v9.88H384.8z" className="son4-84" />
        <path d="M384.8 1004.53h1226.56v9.88H384.8z" className="son4-25" />
        <path d="M384.8 1014.41h1226.56v9.88H384.8z" className="son4-45" />
        <path d="M384.8 1024.3h1226.56v9.88H384.8z" className="son4-77" />
        <path d="M384.8 1034.18h1226.56v9.88H384.8z" className="son4-39" />
        <path d="M384.8 1044.07h1226.56v9.88H384.8z" className="son4-49" />
        <path d="M384.8 1053.95h1226.56v9.88H384.8z" className="son4-63" />
        <path d="M384.8 1063.83h1226.56v9.88H384.8z" className="son4-78" />
        <path d="M384.8 1073.72h1226.56v9.88H384.8z" className="son4-6" />
        <path d="M384.8 1083.6h1226.56v9.88H384.8z" className="son4-23" />
        <path d="M384.8 1093.48h1226.56v9.88H384.8z" className="son4-83" />
        <path d="M384.8 1103.37h1226.56v9.88H384.8z" className="son4-4" />
        <path d="M384.8 1113.25h1226.56v9.88H384.8z" className="son4-85" />
        <path d="M384.8 1123.14h1226.56v9.88H384.8z" className="son4-30" />
        <path d="M384.8 1133.02h1226.56v9.88H384.8z" className="son4-22" />
        <path d="M384.8 1142.9h1226.56v9.88H384.8z" className="son4-82" />
        <path d="M384.8 1152.79h1226.56v9.88H384.8z" className="son4-41" />
        <path d="M384.8 1162.67h1226.56v9.88H384.8z" className="son4-60" />
        <path d="M384.8 1172.56h1226.56v9.88H384.8z" className="son4-61" />
        <path d="M384.8 1182.44h1226.56v9.88H384.8z" className="son4-37" />
        <path d="M384.8 1192.32h1226.56v9.88H384.8z" className="son4-15" />
        <path d="M384.8 1202.21h1226.56v9.88H384.8z" className="son4-31" />
        <path d="M384.8 1212.09h1226.56v9.88H384.8z" className="son4-7" />
        <path d="M384.8 1221.97h1226.56v9.88H384.8z" className="son4-19" />
        <path d="M384.8 1231.86h1226.56v9.88H384.8z" className="son4-65" />
        <path d="M384.8 1241.74h1226.56v9.88H384.8z" className="son4-64" />
        <path d="M384.8 1251.63h1226.56v9.88H384.8z" className="son4-62" />
        <path d="M384.8 1261.51h1226.56v9.88H384.8z" className="son4-80" />
        <path d="M384.8 1271.39h1226.56v9.88H384.8z" className="son4-32" />
        <path d="M384.8 1281.28h1226.56v9.88H384.8z" className="son4-47" />
        <path d="M384.8 1291.16h1226.56v9.88H384.8z" className="son4-18" />
        <path d="M384.8 1301.05h1226.56v9.88H384.8z" className="son4-75" />
        <path d="M384.8 1310.93h1226.56v9.88H384.8z" className="son4-68" />
        <path
          d="M384.8 1320.81h1226.56v9.88H384.8zM384.8 1330.7h1226.56v282.59H384.8z"
          className="son4-54"
        />

        <path
          d="M628.43 523.99c2.68-1.1 5.31-2.28 7.91-3.52-3.41-.22-6.78-.51-10.13-.87.74 1.46 1.47 2.93 2.22 4.39Z"
          style={{
            fill: "#0c9148",
          }}
        />
        <path
          d="M310.76 1072.58c-1.44 12.42-73.38-7.36-157.24 36.6-65.52 34.35-88.54 81.53-100.78 74.24-15.28-9.1-2.64-96.51 54.39-136.19 79.21-55.11 205.55 8.68 203.62 25.34Z"
          className="son4-5"
        />
        <path
          d="M588.16 1602.25c-32.59.34-65.18.68-97.78 1.03a518.84 518.84 0 0 0 5.38-26.26c9.69-54.24 17.08-144.73-14.81-248.31-41.77-135.7-127.44-217.47-168.77-251.69-.07-.05-.12-.1-.19-.16-.83-.68-1.64-1.35-2.43-2-.04-.03-.08-.07-.12-.1-.62-.51-1.23-1-1.82-1.48-.27-.21-.52-.42-.77-.63-.74-.59-1.46-1.17-2.17-1.73.88.42 1.78.85 2.68 1.29.43.2.86.41 1.28.62.5.25 1.02.49 1.53.75.08.03.14.07.22.1.35.17.7.34 1.06.51 1.05.52 2.11 1.05 3.19 1.6 1.23.61 2.47 1.24 3.74 1.89h.03c47.18 24.16 121.23 71.15 181.52 155.88 111.02 156.01 93.91 325.43 88.22 368.68Z"
          className="son4-1"
        />
        <path
          d="M307.93 1076.03c12.02-3.44-19.22-71.2 10.5-161.1 23.22-70.24 66.02-100.63 56.83-111.52-11.47-13.59-95.65 13.12-125.51 75.84-41.48 87.13 42.04 201.39 58.17 196.78Z"
          className="son4-5"
        />
        <path
          d="M309.43 1076.32c9.98 7.53 45.29-58.21 134.96-88.59 70.07-23.74 120.1-7.86 123.26-21.75 3.95-17.34-68.05-68.48-136.11-54.57-94.54 19.33-135.51 154.8-122.11 164.9Z"
          className="son4-5"
        />
        <path
          d="M312.21 1076.82c0 .07 0 .12-.02.19-.28 2.47-2.16 5.97-5.14 10.57-13.51 20.83-49.65 63.96-61.17 134.03-12 72.99 11.81 119.77-1.38 125.16-16.47 6.72-78.65-55.99-76.01-125.41 2.8-73.33 76.88-127.02 117.57-143.47 2.9-1.17 5.63-2.15 8.15-2.93 2.2-.69 4.23-1.23 6.09-1.62 2.56-.52 4.76-.76 6.56-.7.21 0 .42.02.62.04.42.03.81.08 1.18.14.61.12 1.15.29 1.61.51.09.03.17.07.25.12.29.15.56.34.78.55.06.06.11.11.17.18.6.67.84 1.54.74 2.62Z"
          className="son4-5"
        />
        <path
          d="M455.27 1207.84c-43.54-61.19-94.27-102.7-136.85-130.15h-.03c-1.11-.72-2.23-1.43-3.33-2.13-1.46-.92-2.9-1.83-4.34-2.71-.03-.02-.05-.03-.07-.05.39 1.97.79 3.94 1.15 5.88.19-.59.33-1.16.39-1.67 41.34 34.22 127 116 168.77 251.69 31.88 103.58 24.5 194.07 14.81 248.31 15.91-.16 31.82-.32 47.73-.49 5.68-43.25 22.79-212.68-88.23-368.68Z"
          className="son4-66"
        />
        <path
          d="M311.86 1074.64c-6.17 2.98-91.74 46.05-102.94 140.36-8.23 69.26 29.19 119.59 37.51 130.26 8.6-9.56-11.86-55.05-.56-123.8 14.96-90.97 71.38-136.53 65.98-146.83Z"
          className="son4-11"
        />
        <path
          d="M309.33 1073.28c-6.1-3.13-92.03-45.45-174.05 2.45-60.23 35.18-77.84 95.36-81.34 108.43 12.81 1.1 36.78-42.64 98.45-75.05 81.61-42.88 151.97-25.32 156.93-35.83Z"
          className="son4-11"
        />
        <path
          d="M376.18 805.14c-6.17 2.98-91.74 46.05-102.94 140.36-8.23 69.26 29.19 119.59 37.51 130.26 8.6-9.56-11.86-55.05-.56-123.8 14.96-90.97 71.38-136.53 65.98-146.83Z"
          className="son4-11"
        />
        <path
          d="M563.98 969.11c-6.1-3.13-92.06-45.4-174.05 2.55-60.21 35.21-77.79 95.41-81.28 108.48 12.81 1.09 36.76-42.67 98.41-75.11 81.58-42.93 151.95-25.41 156.91-35.92Z"
          className="son4-11"
        />
        <path
          d="M1689.24 1072.58c1.44 12.42 73.38-7.36 157.24 36.6 65.52 34.35 88.54 81.53 100.78 74.24 15.28-9.1 2.64-96.51-54.39-136.19-79.21-55.11-205.55 8.68-203.62 25.34Z"
          className="son4-5"
        />
        <path
          d="M1411.84 1602.25c32.59.34 65.18.68 97.78 1.03a518.84 518.84 0 0 1-5.38-26.26c-9.69-54.24-17.08-144.73 14.81-248.31 41.77-135.7 127.44-217.47 168.77-251.69.07-.05.12-.1.19-.16.83-.68 1.64-1.35 2.43-2 .04-.03.08-.07.12-.1.62-.51 1.23-1 1.82-1.48.27-.21.52-.42.77-.63.74-.59 1.46-1.17 2.17-1.73-.88.42-1.78.85-2.68 1.29-.43.2-.86.41-1.28.62-.5.25-1.02.49-1.53.75-.08.03-.14.07-.22.1-.35.17-.7.34-1.06.51-1.05.52-2.11 1.05-3.19 1.6-1.23.61-2.47 1.24-3.74 1.89h-.03c-47.18 24.16-121.23 71.15-181.52 155.88-111.02 156.01-93.91 325.43-88.22 368.68Z"
          className="son4-1"
        />
        <path
          d="M1692.07 1076.03c-12.02-3.44 19.22-71.2-10.5-161.1-23.22-70.24-66.02-100.63-56.83-111.52 11.47-13.59 95.65 13.12 125.51 75.84 41.48 87.13-42.04 201.39-58.17 196.78Z"
          className="son4-5"
        />
        <path
          d="M1690.57 1076.32c-9.98 7.53-45.29-58.21-134.96-88.59-70.07-23.74-120.1-7.86-123.26-21.75-3.95-17.34 68.05-68.48 136.11-54.57 94.54 19.33 135.51 154.8 122.11 164.9Z"
          className="son4-5"
        />
        <path
          d="M1687.79 1076.82c0 .07 0 .12.02.19.28 2.47 2.16 5.97 5.14 10.57 13.51 20.83 49.65 63.96 61.17 134.03 12 72.99-11.81 119.77 1.38 125.16 16.47 6.72 78.65-55.99 76.01-125.41-2.8-73.33-76.88-127.02-117.57-143.47-2.9-1.17-5.63-2.15-8.15-2.93-2.2-.69-4.23-1.23-6.09-1.62-2.56-.52-4.76-.76-6.56-.7-.21 0-.42.02-.62.04-.42.03-.81.08-1.18.14-.61.12-1.15.29-1.61.51-.09.03-.17.07-.25.12-.29.15-.56.34-.78.55-.06.06-.11.11-.17.18-.6.67-.84 1.54-.74 2.62Z"
          className="son4-5"
        />
        <path
          d="M1544.73 1207.84c43.54-61.19 94.27-102.7 136.85-130.15h.03c1.11-.72 2.23-1.43 3.33-2.13 1.46-.92 2.9-1.83 4.34-2.71.03-.02.05-.03.07-.05-.39 1.97-.79 3.94-1.15 5.88-.19-.59-.33-1.16-.39-1.67-41.34 34.22-127 116-168.77 251.69-31.88 103.58-24.5 194.07-14.81 248.31-15.91-.16-31.82-.32-47.73-.49-5.68-43.25-22.79-212.68 88.23-368.68Z"
          className="son4-66"
        />
        <path
          d="M1688.14 1074.64c6.17 2.98 91.74 46.05 102.94 140.36 8.23 69.26-29.19 119.59-37.51 130.26-8.6-9.56 11.86-55.05.56-123.8-14.96-90.97-71.38-136.53-65.98-146.83Z"
          className="son4-11"
        />
        <path
          d="M1690.67 1073.28c6.1-3.13 92.03-45.45 174.05 2.45 60.23 35.18 77.84 95.36 81.34 108.43-12.81 1.1-36.78-42.64-98.45-75.05-81.61-42.88-151.97-25.32-156.93-35.83Z"
          className="son4-11"
        />
        <path
          d="M1623.82 805.14c6.17 2.98 91.74 46.05 102.94 140.36 8.23 69.26-29.19 119.59-37.51 130.26-8.6-9.56 11.86-55.05.56-123.8-14.96-90.97-71.38-136.53-65.98-146.83Z"
          className="son4-11"
        />
        <path
          d="M1436.02 969.11c6.1-3.13 92.06-45.4 174.05 2.55 60.21 35.21 77.79 95.41 81.28 108.48-12.81 1.09-36.76-42.67-98.41-75.11-81.58-42.93-151.95-25.41-156.91-35.92Z"
          className="son4-11"
        />
        <path
          d="M1595.11 1613.28H384.79c-1.17-32.16.53-101.51 39.08-143.73 67-73.36 194.81-9.46 206.35-3.49 45.31 23.43 49.51 43.89 89.27 52.48 53.06 11.47 81.08-17.28 130.75-27.41 82.6-16.85 106.59 41.97 191.3 56.39 137.92 23.48 165.84-116.87 339.93-116.49 31.79.07 150.83.33 196.16 92.86 15.63 31.91 18.02 65.65 17.48 89.38Z"
          className="son4-38"
        />
        <path
          d="M1410.59 1567c-57.29 30.57-92.82 1.12-204.92-4.86-141.78-7.56-136.64 36.79-268.04 29.14-138.56-8.07-139.66-57.12-244.74-43.7-58.49 7.47-117.48 30.24-165.1-1.94-12.75-8.62-27.27-22.92-55.03-32.21-28.29-9.47-54.42-8.4-72.35-5.92-15.79 38.31-16.48 82.11-15.62 105.77h1210.32c.54-23.73-1.85-57.47-17.48-89.38-.49-1.01-1.01-1.99-1.52-2.98-9.32-8.46-24.3-19.36-44-21.76-46.87-5.71-73.71 42.33-121.52 67.84Z"
          style={{
            fill: "#eaa907",
          }}
        />
        {children}
      </g>
    </svg>
  );
}
